import React from "react";

const InitializeKiosk = () => {
  return <div>InitializeKiosk</div>;
};

export default InitializeKiosk;
